import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import * as React from 'react';

import {
  default as BaseButton,
  type LegacyButtonProps as ButtonProps,
} from 'src/components/lib/new-button/lib-button';
import makeClassNameComponent from 'src/utils/makeClassNameComponent';

import HoverIconButton from 'src/components/lib/hover-icon-button/index';
import CancelIcon from 'src/images/icons/cancel-icon.svg?noAttrs';
import ConfirmIcon from 'src/images/icons/confirm-icon.svg?noAttrs';
import WarningIcon from 'src/images/icons/warning-icon.svg?noAttrs';

import css from './base-modal.css';

// @ts-expect-error TS2322
export const Container: Flow_AbstractComponent<React.ComponentProps<never>> =
  makeClassNameComponent(css.titleBarContainer);
// @ts-expect-error TS2322
export const Content: Flow_AbstractComponent<React.ComponentProps<never>> =
  makeClassNameComponent(css.container);
// @ts-expect-error TS2322
export const TextContent: Flow_AbstractComponent<React.ComponentProps<never>> =
  makeClassNameComponent(css.textContent);
// @ts-expect-error TS2322
export const Buttons: Flow_AbstractComponent<React.ComponentProps<never>> =
  makeClassNameComponent(css.buttonMenu);

export function Button(props: ButtonProps) {
  return <BaseButton {...props} />;
}

export function SuccessTitleBar({
  children,
  onClose,
}: {
  children: string;
  onClose?: ((arg1: React.SyntheticEvent) => unknown) | null | undefined;
}) {
  return (
    <TitleBar
      title={children}
      // @ts-expect-error - TS2322 - Type '{ style: { fill: string; }; }' is not assignable to type 'IntrinsicAttributes'.
      icon={<ConfirmIcon style={{fill: css.colorWhite}} />}
      color={css.modalGreen}
      onClose={onClose}
    />
  );
}

export function WarningTitleBar({
  children,
  onClose,
}: {
  children: string;
  onClose: ((arg1: React.SyntheticEvent) => unknown) | null | undefined;
}) {
  return (
    <TitleBar
      title={children}
      // @ts-expect-error - TS2322 - Type '{ style: { fill: string; }; }' is not assignable to type 'IntrinsicAttributes'.
      icon={<WarningIcon style={{fill: css.colorWhite}} />}
      color={css.modalOrange}
      onClose={onClose}
    />
  );
}

export function TitleBar({
  title,
  icon,
  color,
  onClose,
}: {
  title: string;
  icon: React.ReactNode | null | undefined;
  color: string;
  onClose?: ((arg1: React.SyntheticEvent) => unknown) | null | undefined;
}): React.ReactElement<React.ComponentProps<'div'>> {
  return (
    <div className={css.titleBar} style={{backgroundColor: color}}>
      <div className={css.titleAndIcon}>
        <span className={css.titleIcon}>{icon}</span>
        <div className={css.title}>{title}</div>
      </div>
      {onClose && (
        <HoverIconButton className={css.closeXHoverButton}>
          {/* @ts-expect-error - TS2322 - Type '{ className: string; onClick: (arg1: SyntheticEvent<Element, Event>) => unknown; }' is not assignable to type 'IntrinsicAttributes'. */}
          <CancelIcon className={css.closeXIcon} onClick={onClose} />
        </HoverIconButton>
      )}
    </div>
  );
}
